import { FieldConfigItemSchema, FieldConfigSchema } from "../../types"
import { FieldConfigItem } from "./fieldConfigItemModel"

export class FieldConfig {
  private fieldConfigJson: FieldConfigSchema
  constructor(fieldConfigJson: FieldConfigSchema) {
    this.fieldConfigJson = fieldConfigJson
  }

  hasField(key: string): boolean {
    return Object.keys(this.fieldConfigJson).includes(key)
  }

  getAllFieldConfigItemEntities(): FieldConfigItem[] {
    return Object.values(this.fieldConfigJson).map((fieldConfigItemJson) => new FieldConfigItem(fieldConfigItemJson))
  }

  getFieldConfigItem(key: string): FieldConfigItemSchema | undefined {
    if (!this.hasField(key)) {
      return
    }
    return this.fieldConfigJson[key]
  }

  getFieldConfigItemEntity(key: string): FieldConfigItem | undefined {
    if (!this.hasField(key)) {
      return
    }
    return new FieldConfigItem(this.fieldConfigJson[key])
  }

  getLabel(key: string): string {
    const maybeFieldConfigItemEntity = this.getFieldConfigItemEntity(key)
    if (!maybeFieldConfigItemEntity) {
      return ""
    }
    return maybeFieldConfigItemEntity.getLabel()
  }

  getKeyForLabel(label: string): string | undefined {
    const allFieldConfigItemEntities = this.getAllFieldConfigItemEntities()
    for (const fieldConfigItemEntity of allFieldConfigItemEntities) {
      if (fieldConfigItemEntity.getLabel() === label) {
        return fieldConfigItemEntity.getKey()
      }
    }
    return undefined
  }

  getAllAvailableKeys() {
    return Object.keys(this.fieldConfigJson)
  }

  getAllAvailableLabels() {
    const labels = this.getAllAvailableKeys().map((key) => {
      try {
        const label = this.getLabel(key)
        return label
      } catch (error) {}
      return ""
    })
    return labels.filter((label) => label !== "")
  }
}
